import { combineReducers } from 'redux';

// reducer import
import applicationReducer from './applicationReducer';
import customizationReducer from './customizationReducer';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    applstore: applicationReducer,
    customization: customizationReducer
});

export default reducer;
